import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../lib/api';
import { PageHead, Section } from '../components/ui';

export default function NewGroupPage() {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [location, setLocation] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    setBusy(true);
    try {
      const group = await api.createGroup({
        name: name.trim(),
        description: description.trim() || null,
        location: location.trim() || null,
      });
      navigate(`/group/${group.id}`);
    } catch (err) { alert(err.message); setBusy(false); }
  };

  return (
    <div className="page">
      <PageHead breadcrumb={<a onClick={() => navigate('/groups')} style={{ cursor: 'pointer' }}>Groups</a>} title="New group" />
      <form onSubmit={submit} style={{ maxWidth: 560 }}>
        <Section>
          <div className="form-field"><label>Group name <span className="req">*</span></label><input className="input" value={name} onChange={(e) => setName(e.target.value)} autoFocus /></div>
          <div className="form-field"><label>Description</label><textarea className="textarea" value={description} onChange={(e) => setDescription(e.target.value)} placeholder="What's this group for?" /></div>
          <div className="form-field"><label>Location</label><input className="input" value={location} onChange={(e) => setLocation(e.target.value)} placeholder="address, zoom link, etc." /></div>
          <button className="btn btn-primary" disabled={busy || !name.trim()}>{busy ? 'Creating…' : 'Create group'}</button>
        </Section>
      </form>
    </div>
  );
}
